import React from 'react'
import styled from 'styled-components'
import Colors from 'styles/Colors'
import media from 'styles/media'
import { Body3, HeadlineM, HeadlineS, Overline } from 'components/Text'
import { Paragraph } from 'components/richTextOptions'
import { ReactComponent as BGElementSVG } from 'svg/BG Element_right.svg'

const Features: React.FC<{}> = () => {
  return (
    <Wrapper>
      <List>
        <Item>
          <Subtitle>Automated programming</Subtitle>
          <Paragraph>
            Realtime’s solution is designed to set up path segments, then
            automatically package projects within minutes.
          </Paragraph>
        </Item>
        <Item>
          <Subtitle>Expedite commissioning</Subtitle>
          <Paragraph>
            Eliminate manual calculation and iterative programming of every
            robot combination.
          </Paragraph>
        </Item>
        <Item>
          <Subtitle>Automate processes</Subtitle>
          <Paragraph>
            From simulation and robot engineers to operators, work in a unified
            software program, automating processes and minimizing error.
          </Paragraph>
        </Item>
      </List>
      <List>
        <Item>
          <Subtitle>Freedom of brand choice</Subtitle>
          <Paragraph>
            Remove the dependency on any robot manufacturer – mix and match
            brands in one cell. We remove reliance on brand-specific robot
            programming.
          </Paragraph>
        </Item>
        <Item>
          <Subtitle>
            Upskill
            <br />
            workforce
          </Subtitle>
          <Paragraph>
            Easily train your team to recover from downtime or make workcell
            changes to free up your highly technical resources.
          </Paragraph>
        </Item>
        <Item>
          <Subtitle></Subtitle>
          <Paragraph></Paragraph>
          <BGElement />
        </Item>
      </List>
      <BGElement />
    </Wrapper>
  )
}

const Wrapper = styled.section`
  height: 548px;
  padding-top: 112px;
  position: relative;
  min-height: 935px;
  ${media.tabletLandscape} {
    min-height: 1100px;
  }
  ${media.tablet} {
    background: ${Colors.whiteSmoke};
    height: 264px;
    padding-top: 48px;
    min-height: 900px;
  }
  ${media.mobile} {
    height: 414px;
    min-height: 1400px;
  }
`
const List = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: 80%;
  margin-left: 96px;
  list-style-type: none;
  justify-content: space-around;
  @media screen and (max-width: 1255px) {
    justify-content: space-around;
  }
  ${media.tabletLandscape} {
    float: left;
    width: 40%;
    display: block;
  }
  ${media.tablet} {
    margin-left: 48px;
    display: block;
    margin-bottom: 58px;
  }
  ${media.mobile} {
    margin-left: 12px;
    float: none;
    width: 100%;
  }
`

const Item = styled.span`
  width: 25%;
  font-size: 24px;
  text-transform: none;
  display: block;
  position: relative;
  &:nth-child(1),
  &:nth-child(2) {
    margin-bottom: 144px;
  }
  box-sizing: content-box;
  @media screen and (max-width: 1255px) {
    &:nth-child(odd) {
      margin-right: 60px;
    }
  }
  ${media.tabletLandscape} {
    font-size: 16px;
    width: 284px;
    &:nth-child(1),
    &:nth-child(2) {
      margin-bottom: 58px;
    }
    ::after {
      font-size: 16px;
    }
  }
  ${media.tablet} {
    color: white;
    font-weight: bold;
  }
  ${media.mobile} {
    margin-bottom: 48px;
    &:nth-child(1),
    &:nth-child(2) {
      margin-bottom: 48px;
    }
    &:nth-child(odd) {
      margin-right: 0;
    }
    max-width: 329px;
    width: unset;
  }
`
const Title = styled(HeadlineM)`
  margin-left: 96px;
  margin-bottom: 99px;
  ${media.tabletLandscape} {
    font-size: 54px;
  }
  ${media.mobile} {
    font-size: 36px;
    margin-top: 15px;
    margin-left: 12px;
  }
`

const Subtitle = styled(HeadlineS)`
  margin-bottom: 24px;
  font-family: 'Maison Neue';
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 36px;
  letter-spacing: 0.0015em;
`
const Label = styled(Overline)`
  color: black;
  margin-bottom: 1vw;
  ::after {
    color: ${Colors.neptune};
    top: 0;
  }
  ${media.fullWidth} {
    font-size: 0.8vw;
  }
`

const BGElement = styled(BGElementSVG)`
  position: absolute;
  width: 23.9vw;
  height: 26.1vw;
  left: 66.3vw;
  top: 26.9vw;
  z-index: 5;
  transform: rotate(0deg);
  ${media.tabletLandscape} {
    display: none;
  }
  ${media.tablet} {
  }
`

export default Features
